export default {
  SET_STATE: 'refunds/SET_STATE',
  FETCH_REFUNDS: 'refunds/FETCH_REFUNDS',
}
